export class SelectOption {
	name: string;
	slug: string;
	icon?: string;
}